import intl from "react-intl-universal";
import { formatCurrency } from "../../../../Utils/formatters";

const formatUsageDate = (value) => {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "—";
  return new Intl.DateTimeFormat(undefined, {
    dateStyle: "short",
    timeStyle: "short",
  }).format(date);
};

const shortenId = (id) => {
  const value = String(id || "").trim();
  if (!value) return "—";
  if (value.length <= 18) return value;
  return `${value.slice(0, 10)}…${value.slice(-6)}`;
};

/**
 * Completed txs that compose UTILIZADO (same source as used_cents).
 * Empty list when used is 0 — does not wait for the next operation.
 */
export const StablesLimitUsageList = ({ usage = [] }) => {
  const items = Array.isArray(usage) ? usage : [];

  return (
    <div className="mt-2.5 border-t border-dashed border-gray-200 pt-2.5 dark:border-brand-dark-border">
      <p className="text-[10px] font-medium uppercase tracking-wide text-gray-400 dark:text-gray-500">
        {intl.get("baas.stablesWallet.limits.usageTitle")}
      </p>
      {items.length === 0 ? (
        <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
          {intl.get("baas.stablesWallet.limits.usageEmpty")}
        </p>
      ) : (
        <ul className="mt-1.5 divide-y divide-gray-100 dark:divide-brand-dark-border">
          {items.map((tx) => (
            <li
              key={tx.id || tx.transactionId}
              className="flex items-start justify-between gap-2 py-1.5 first:pt-0 last:pb-0"
            >
              <div className="min-w-0">
                <p className="truncate text-xs font-medium text-brand-dark dark:text-gray-200">
                  {tx.asset || "—"}
                  <span className="ml-1.5 font-normal text-gray-400 dark:text-gray-500">
                    {formatUsageDate(tx.completedAt)}
                  </span>
                </p>
                <p
                  className="truncate font-mono text-[10px] text-gray-400 dark:text-gray-500"
                  title={tx.id}
                >
                  {shortenId(tx.id)}
                </p>
              </div>
              <p className="shrink-0 text-xs font-semibold tabular-nums text-brand-dark dark:text-gray-100">
                {formatCurrency(Number(tx.usedCents) || 0)}
              </p>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
